import { render, staticRenderFns } from "./SectionItemSKUForApi.vue?vue&type=template&id=48d99a3e&scoped=true&lang=pug&"
import script from "./SectionItemSKUForApi.vue?vue&type=script&lang=js&"
export * from "./SectionItemSKUForApi.vue?vue&type=script&lang=js&"
import style0 from "./SectionItemSKUForApi.vue?vue&type=style&index=0&id=48d99a3e&scoped=true&lang=scss&"
import style1 from "./SectionItemSKUForApi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d99a3e",
  null
  
)

export default component.exports